import PropTypes from 'prop-types';

// Actions
export const CLEAR_FETCH_STATUS = 'CLEAR_FETCH_STATUS';
export const SET_FETCH_STATUS_ERROR = 'SET_FETCH_STATUS_ERROR';
export const SET_FETCH_STATUS_LOADED = 'SET_FETCH_STATUS_LOADED';
export const SET_FETCH_STATUS_LOADING = 'SET_FETCH_STATUS_LOADING';

// Action Creators
export function isLoading(name, id) {
  return {
    type: SET_FETCH_STATUS_LOADING,
    payload: { name, id },
  };
}

export function isLoaded(name, id) {
  return {
    type: SET_FETCH_STATUS_LOADED,
    payload: { name, id },
  };
}

export function isFailed(name, id) {
  return {
    type: SET_FETCH_STATUS_ERROR,
    payload: { name, id },
  };
}

export function clearLoadingState(name) {
  return {
    type: CLEAR_FETCH_STATUS,
    payload: { name },
  };
}

const INITIAL_STATE = {
  currentRequests: {},
};

// Reducer
export function loading(state = INITIAL_STATE, action) {
  if (!action.error && action.payload) {
    const newLoadingState = { ...state };
    const { name, id = '' } = action.payload;

    switch (action.type) {
      case SET_FETCH_STATUS_LOADING: {
        newLoadingState[name] = 'loading';
        newLoadingState.currentRequests[name] = newLoadingState.currentRequests[name] ? newLoadingState.currentRequests[name] : [];
        newLoadingState.currentRequests[name].push(id);
        break;
      }
      case SET_FETCH_STATUS_LOADED: {
        newLoadingState[name] = 'complete';
        newLoadingState.currentRequests[name] = newLoadingState.currentRequests[name] ? newLoadingState.currentRequests[name] : [];
        const completedRequest = newLoadingState.currentRequests[name].indexOf(id);
        const requestExists = (completedRequest > -1) ? 1 : 0;
        newLoadingState.currentRequests[name].splice(completedRequest, requestExists);
        break;
      }
      case SET_FETCH_STATUS_ERROR: {
        newLoadingState[name] = 'error';
        newLoadingState.currentRequests[name] = newLoadingState.currentRequests[name] ? newLoadingState.currentRequests[name] : [];
        const completedRequest = newLoadingState.currentRequests[name].indexOf(id);
        const requestExists = (completedRequest > -1) ? 1 : 0;
        newLoadingState.currentRequests[name].splice(completedRequest, requestExists);
        break;
      }
      case CLEAR_FETCH_STATUS: {
        newLoadingState.currentRequests[name] = newLoadingState.currentRequests[name] ? newLoadingState.currentRequests[name] : [];
        newLoadingState[name] = '';
        break;
      }
      default: {
        return state;
      }
    }
    return newLoadingState;
  }
  return state;
}

// PropType description of loading object
export const LOADING_PROP_TYPE =
PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string))]));



// WEBPACK FOOTER //
// ./src/modules/loading/loading.js